<template>
        <ion-page>
            <ion-header :translucent="true">
            <ion-toolbar>
                <ion-buttons slot="start">
                <ion-menu-button color="primary"></ion-menu-button>
                </ion-buttons>
                <ion-title>My Received IOU Requests</ion-title>
            </ion-toolbar>
            </ion-header>
            
            <ion-content :fullscreen="true">
            <ion-header collapse="condense">
                <ion-toolbar>
                <ion-title size="large">My Received IOU Requests</ion-title>
                </ion-toolbar>
            </ion-header>
            
            <div id="container">
                <DataTable :loading="loading" class="p-datatable-sm" showGridlines :value="iouRequests" :lazy="true" :paginator="true" :rows="perPage" :totalRecords="total"  @page="onPage($event)" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink" responsiveLayout="stack" :rowClass="data=>{ return 'dataRow'}" :stripedRows="true">
                    <template #loading>
                        Loading data, please wait...
                    </template>
                    <template #empty>
                        No records found
                    </template>
                    <Column field="id" header="ID"></Column>
                    <Column field="amount" header="Amount"></Column>
                    <Column field="iouType" header="IOU Type"></Column>
                    <Column field="purpose" header="Purpose"></Column>
                    <Column field="from" header="From"></Column>
                    <Column field="iou" header="Current IOU Balance"></Column>
                    <Column field="createdAt" header="Created At"></Column>
                    <Column field="iouStatus" header="Status">
                    <template #body="{data}">
                        <!-- {{data.status}} -->
                        <div v-html="data.status"></div>
                        <div v-if="data.iouStatus=='pending'">
                            <ion-button @click="approve(data.id)" size="small">Approve</ion-button>
                            <ion-button @click="decline(data.id)" size="small" color="warning">Decline</ion-button>
                        </div>
                    </template>
                    </Column>
                    <Column field="confirmationStatus" header="Confirmation Status">
                        <template #body="{data}">
                            <div v-html="data.confirmationStatus"></div>
                        </template>
                    </Column>
                </DataTable>
            </div>
            </ion-content>
        </ion-page>
</template>

<script >
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonButton, alertController } from '@ionic/vue';
import { defineComponent } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

export default defineComponent({
  name: 'My Received IOU Requests',
  data(){
      return {
          iouRequests:[],
          loading:false,
          perPage:10,
          total:0,
      }
  },
  mounted(){
      this.loadData(0);
  },
  methods:{
      async loadData(page){
          const data={
              'page':page + 1,
              'username':window.localStorage.username,
              'password':window.localStorage.password,
          };
          this.loading=true;
        this.$http.post('myReceivedIOURequests',data).then(response=>{
            // const rows=[];
            this.perPage=response.data.per_page;
            this.total=response.data.total;
            const reqs=[];
            for(const req of response.data.data){
                reqs.push({
                    id:req.id,
                    amount:req.amount,
                    iouType:req.iou_type,
                    purpose:req.purpose,
                    from:req.user.name,
                    iou:req.user.iou,
                    createdAt: req.created_at,
                    iouStatus: req.iou_status,
                    status:req.iou_status!="pending"? req.iou_status+"<br>At: "+req.iou_approved_or_declined_at +(req.iou_status=="declined"?"<br>Reason: "+req.iou_declined_reason:"") : req.iou_status,
                    confirmationStatus:req.iou_status=="approved" ? req.confirmation_status!="pending"?req.confirmation_status+"<br>At:"+req.confirmed_or_declined_at:req.confirmation_status:"",
                });
            }
            this.iouRequests=reqs;
            this.loading=false;
        });

      },
      onPage(event){
          this.loadData(event.page);
      },
      approve(id){
          this.presentConfirmationAlert(async ()=>{
              const data={
                'id':id,
                'username':window.localStorage.username,
                'password':window.localStorage.password,
              };
              this.$http.post('approveIOURequest',data).then(response=>{
                  if(response.data.status){
                      for(const i in this.iouRequests){
                          if(this.iouRequests[i].id==id){
                              const req=response.data.data;
                            this.iouRequests[i]={
                                id:req.id,
                                amount:req.amount,
                                purpose:req.purpose,
                                from:req.user.name,
                                createdAt: req.created_at,
                                iouStatus: req.iou_status,
                                status:req.iou_status!="pending"? req.iou_status+"<br>At: "+req.iou_approved_or_declined_at +(req.iou_status=="declined"?"<br>Reason: "+req.iou_declined_reason:"") : req.iou_status,
                                confirmationStatus:req.iou_status=="approved" ? req.confirmation_status!="pending"?req.confirmation_status+"<br>At:"+req.confirmed_or_declined_at:req.confirmation_status:"",
                            };
                            break;
                          }
                      }
                  }
              });
          });
      },
      decline(id){
        //   console.log(id);
          this.presentDeclineAlert(async alertData=>{
              if(alertData.reason!=null){
                  const data={
                    'id':id,
                    'decline_message':alertData.reason,
                    'username':window.localStorage.username,
                    'password':window.localStorage.password,
                };
                this.$http.post('declineIOURequest',data).then(response=>{
                    if(response.data.status){
                      for(const i in this.iouRequests){
                          if(this.iouRequests[i].id==id){
                              const req=response.data.data;
                            this.iouRequests[i]={
                                id:req.id,
                                amount:req.amount,
                                purpose:req.purpose,
                                from:req.user.name,
                                createdAt: req.created_at,
                                iouStatus: req.iou_status,
                                status:req.iou_status!="pending"? req.iou_status+"<br>At: "+req.iou_approved_or_declined_at +(req.iou_status=="declined"?"<br>Reason: "+req.iou_declined_reason:"") : req.iou_status,
                                confirmationStatus:req.iou_status=="approved" ? req.confirmation_status!="pending"?req.confirmation_status+"<br>At:"+req.confirmed_or_declined_at:req.confirmation_status:"",
                            };
                            break;
                          }
                      }
                    }
                });
              }
          });
      },
      async presentConfirmationAlert(todo) {
      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          header: 'Alert',
          message: 'Do you really want to approve this IOU.',
          buttons: [
            {
                text: "No",
                role: 'cancel',
            },
            {
                text: 'Yes',
                role: 'yes',
                handler: todo,
            }
          ],
        });
      await alert.present();
    },
      async presentDeclineAlert(todo) {
      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          message: 'Why you want to decline this IOU Request?',
          inputs:[
              {
                  type:'textarea',
                  label:'Reason',
                  name:'reason'
              }
          ],
          buttons: [
            {
                text: "Cancel",
                role: 'cancel',
            },
            {
                text: 'Proceed',
                role: 'yes',
                handler: todo,
            }
          ],
        });
      await alert.present();
    },

  },
  components: {
    IonButtons,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    DataTable,
    Column,
    IonButton
  }
});
</script>

<style scoped>
.dataRow:nth-child(even){
    background-color: #f2f2f2 !important;
}
</style>